import type { ReactNode } from "react";

import { classNames, Icon, Text } from "@alpacahq/ui/old";

export interface SubTypeBoxProps {
  onClick: () => void;
  isSelected: boolean;
  icon: ReactNode;
  title: string;
  badge: ReactNode;
  list: string[];
}

export const SubTypeBox = ({
  onClick,
  isSelected,
  icon,
  title,
  badge,
  list,
}: SubTypeBoxProps) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      "flex w-full flex-col gap-4 rounded-lg border border-cool-gray-200 bg-white px-4 py-6",
      isSelected && "border-indigo-600 bg-indigo-50",
    )}
  >
    <div className="flex items-center gap-2">
      <div>{icon}</div>
      <h2 className="m-0 p-0 font-semibold text-cool-gray-800 text-lg leading-[26px]">
        {title}
      </h2>
      <div>{badge}</div>
    </div>
    <ul className="flex flex-col gap-4">
      {list.map((li) => (
        <li key={li} className="flex items-center gap-2">
          <Icon name="CheckBadge" className="fill-yellow-300" />
          <Text className="text-gray-700">{li}</Text>
        </li>
      ))}
    </ul>
  </button>
);
